import {
	getComponentCssVariables,
	getProcessedCssWithConfig,
	getSiteCssVariables,
	getBuildTimeStaticCss,
} from '@wix/tpa-style-webpack-plugin/standalone'
import { OOICssConfig, ProcessOoiCssFunctionLib } from '@wix/thunderbolt-becky-types'

export const createCssVarsGenerator = ({
	// eslint-disable-next-line @typescript-eslint/no-shadow
	getSiteCssVariables,
	// eslint-disable-next-line @typescript-eslint/no-shadow
	getComponentCssVariables,
}: Pick<
	typeof import('@wix/tpa-style-webpack-plugin/standalone'),
	'getSiteCssVariables' | 'getComponentCssVariables'
>) => {
	return ({
		styleData,
		prefixSelector,
		options,
		cssConfig,
	}: {
		styleData: {
			siteColors: Array<{ name: string; value: string; reference: string }>
			siteTextPresets: any // todo
			style: any // todo
		}
		prefixSelector: string
		options: Partial<{
			isRTL: boolean
			isMobile: boolean
			dimensions: {
				width: number
				height: number
			}
			usesCssPerBreakpoint: boolean
		}>
		cssConfig?: OOICssConfig
	}) => {
		const { siteColors, siteTextPresets, style: styleParams } = styleData
		const siteCssVars = getSiteCssVariables(siteColors, siteTextPresets)
		const customExpressions = {} // custom json per app->widget
		const widgetCssVars = getComponentCssVariables(
			{ siteColors, siteTextPresets, styleParams },
			customExpressions,
			{},
			{
				...options,
				prefixSelector,
			},
			cssConfig?.defaults,
			cssConfig?.customCssVars
		)
		return `${prefixSelector} {
				${widgetCssVars.stylesheet}
				${siteCssVars.stylesheet}
		}`
	}
}

const generateCssVars = createCssVarsGenerator({
	getSiteCssVariables,
	getComponentCssVariables,
})

// ds implementation - used in ds function library and in catharsis css mappers
// public implementation in ooiCssProcessor which supports styles from app settings - will be refactored to reuse function in other PR
export const processOoiCss: ProcessOoiCssFunctionLib['processOoiCss'] = (
	widgetId,
	styleData,
	{ prefixSelector, cssConfig, isRTL, isMobile, usesCssPerBreakpoint }
): string => {
	if (!cssConfig) {
		return ''
	}
	const options = { isRTL, isMobile, prefixSelector, usesCssPerBreakpoint }
	const cssConfigCss = cssConfig
		? getProcessedCssWithConfig(
				cssConfig,
				{
					siteColors: styleData.siteColors,
					siteTextPresets: styleData.siteTextPresets,
					styleParams: styleData.style,
				},
				options
		  )
		: ''
	const staticCss = cssConfig ? getBuildTimeStaticCss(cssConfig).css : ''
	const cssVars = generateCssVars({ styleData, prefixSelector, cssConfig, options })
	return cssVars + staticCss + cssConfigCss
}
